import * as React from 'react';
import ProjectData from 'src/value-objects/ProjectData';
import { baseApiRoute } from 'src/resources/const';
import RichEditContainer from 'src/modules/commons/inputs/rich-edit/RichEdit.container';

export interface ProjectMarketFormComponentProps {
  formData: ProjectData;
  handleChange: (key: string) => (value: string | File | boolean) => void;
  handleRichEditor: (key: string) => (html: string) => void;
}

class ProjectMarketFormComponent extends React.Component<ProjectMarketFormComponentProps> {

  public render(): React.ReactNode {
    return (
      <div>
        <p className="f-s-26">
          Mercado
        </p>
        <div className="gap-20"/>
        <div className="row">
          <div className="col-md-12">
            <RichEditContainer
              onChange={(value) => this.props.handleRichEditor('marketData')(value)}
              placeholder="Añade la descripción"
              uploadURL={baseApiRoute + '/save-image'}
              value={this.props.formData.marketData}
            />
          </div>
        </div>
        <div className="gap-20"/>
      </div>
    );
  }

}

export default ProjectMarketFormComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectMarketForm.component.tsx